<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <!-- <v-select
            v-model="formData.meter_id"
            :items="meters"
            label="العداد"
            item-title="name"
            item-text="code"
            item-value="id"
            :disabled="mode == 'edit'"
          >
          </v-select> -->
          <v-autocomplete
            v-model="formData.meter_id"
            :items="meters"
            label="العداد"
            item-title="name"
            item-text="code"
            item-value="id"
            :disabled="mode == 'edit'"
          ></v-autocomplete>
          <v-checkbox
            label="تمت المطالبة"
            v-model="formData.isPrompted"
          ></v-checkbox>
          <v-text-field
            type="number"
            v-model="formData.current_value"
            :rules="currentValueRules"
            label="التأشيرة الحالية"
          ></v-text-field>
          <v-text-field
            v-model="formData.notes"
            :rules="notesRules"
            label="ملاحظات"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "meters", "mode", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        meter_id: null,
        current_value: 0,
        isPrompted: false,
        notes: null,
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 25) || "Name must be less than 10 characters",
      ],
      currentValueRules: [(v) => (v && v >= 0) || "minimum is 0 "],
      notesRules: [
        (v) => v === null || (v && v.length <= 25) || "too long notes",
      ],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
    checkChanged() {
      console.log("ccc", "check changed");
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        if (this.mode == "edit") {
          //console.log(this.item);
          this.formData = { ...this.item };
          this.formData.isPrompted = this.item.isPrompted == 1 ? true : false;
        }
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة قراءة";
      return "تعديل قراءة";
    },
  },
};
</script>
